export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 11h8l-3.5-3.5 1.42-1.42L17.84 12l-5.92 5.92-1.42-1.42L14 13H6zm6 11a10 10 0 1 1 10-10c0 5.523-4.477 10-10 10m8-10a8 8 0 1 0-16 0 8 8 0 0 0 16 0\"/>"
};